<template>
  <div class="card mb-0">
    <div v-if="showHeader" class="card-header d-flex">
        <h5 class="h3 mb-0">My Invites</h5>
    </div>

    <div v-if="loaded">
        <div v-if="invites && invites.length > 0">
            <b-list-group flush class="my-pending-invites-list-group">
                <user-pending-invites-item v-for="invite in openInvites" :key="invite.accountInviteId" :invite="invite" @remove-user-invite="removeUserInvite" class="flex-column align-items-start">
                </user-pending-invites-item>
            </b-list-group>
        </div>
        <div v-else class="text-center p-3">
            <div> No pending invites. </div>
        </div>
    </div>
    <div v-else class="text-center p-3">
        <div> Loading... </div>
        <b-spinner size="sm"></b-spinner>
    </div>
    <div class="card-footer">
      <b-form-invalid-feedback :state="!errorMessage" class="text-center">
          {{errorMessage}}
      </b-form-invalid-feedback>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import UserPendingInvitesItem from '#/ui/Components/User/UserPendingInvitesItem.vue';

export default {
  components: {
    UserPendingInvitesItem,
  },
  data() {
    return {
      showHeader: false,
      loaded: false,
      errorMessage: undefined,
    };
  },
  created() {
    this.loadPendingInvites();
  },
  computed: {
    ...mapGetters('user', {
      invites: 'invites',
    }),
    openInvites() {
      return this.invites;
    },
  },
  methods: {
    async loadPendingInvites() {
      return this.$store.dispatch('user/loadPendingInvites').then((data) => {
        console.log('received pending invites', this.invites);
      }).catch((error) => {
        console.error('error loadAccountRoles: ', error);
        this.errorMessage = 'Error loading pending invites';
      }).finally(() => {
        this.loaded = true;
      });
    },
    removeUserInvite(accountInviteId) {
      console.log('removing resolved invite', accountInviteId);
      const index = this.invites.findIndex((invite) => invite.accountInviteId === accountInviteId);
      if (index) {
        this.invites.splice(index, 1);
      }
    },
  },
};
</script>
<style scoped>
</style>
